function Footer() {
    return (
        <>        
        <footer class="footer py-4">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-4 text-lg-start">Copyright &copy; kimchilingua.</div>
                    <div class="col-lg-8 text-lg-end">Todos los derechos reservados. ***Seúl-Corea***</div>
                </div>
            </div>
        </footer>
         </>
    );
  }

export default Footer;